export const LOGIN_CONTEXT = 'mosaikLoginContext'; //Context of currently logged in user
